import { withStyles } from '@material-ui/core'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import withErrorCatcher from '../../../components/Common/withErrorCatcher'
import { useTranslation } from 'react-i18next'

const styles = theme => ({
    container: {
        position: 'relative',
        zIndex: 1,
        marginTop: '10vh',
        marginRight: 'auto',
        marginLeft: "auto",
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
        alignItems: 'center',
    },
    title: {
        color: "#18181B",
        fontFamily: "Rubik",
        fontSize: 24,
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "32px"
    },
    subtitle: {
        color: "#6B6F7A",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "20px"
    },
    btns: {
        marginTop: '3vh',
        display: 'flex',
        marginBottom: '6vh',
        alignItems: 'center'
    },
    btn: {
        marginLeft: 16,
        cursor: 'pointer',
        display: "flex",
        background: '#6366F1',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between",
        padding: '6px 30px',
        borderRadius: 6,
        border: '1px solid transparent',
        height: 20,
        width: 'fit-content'
    },
    btnWhite: {
        border: '1px solid #B7B8BD33',
        cursor: 'pointer',
        display: "flex",
        background: '#fff',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between",
        padding: '6px 30px',
        borderRadius: 6,
        height: 20,
        width: 'fit-content'
    },
    btnText: {
        color: "#fff",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px"
    },
    btnTextWhite: {
        color: "#6B6F7A",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px"
    },
    disabledBtn: {
        pointerEvents: 'none',
        background: '#B7B8BD'
    },
    content1: {
        marginTop: '6vh',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    content: {
        display: 'flex',
        cursor: 'pointer',
        width: '32vw',
        padding: "var(--16, 16px) 16px",
        flexDirection: 'row',
        justifyContent: "flex-start",
        alignItems: "center",
        borderRadius: 12,
        background: '#fff',
        marginRight: 24,
        marginTop: 16,
        boxShadow: "0px 1px 0px 0px rgba(255, 255, 255, 0.08) inset, 0px 0px 0px 1px rgba(255, 255, 255, 0.02) inset, 0px 1px 1px -0.5px var(--modul-shadow, rgba(107, 111, 122, 0.06)), 0px 3px 3px -1.5px var(--modul-shadow, rgba(107, 111, 122, 0.06)), 0px 6px 6px -3px var(--modul-shadow, rgba(107, 111, 122, 0.06)), 0px 12px 12px -6px var(--modul-shadow, rgba(107, 111, 122, 0.06)), 0px 24px 24px -12px var(--modul-shadow, rgba(107, 111, 122, 0.06))",
    },
    label: {
        color: "#18181B",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px"
    },
    titles: {
        marginLeft: 12
    },
    selLabel: {
        color: '#6366F1',
    },
    labelDesc: {
        color: "#6B6F7A",
        fontFamily: "Rubik",
        fontSize: 12,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "16px"
    },
    sign: {
    },
})

const SAAS1 = ({selected}) => <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_i_1199_24166)">
<rect width="40" height="40" rx="20" fill="#B7B8BD" fill-opacity="0.07"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.8 18.3246C21.4419 19.0588 20.9836 19.81 20.3968 20.3967C19.8101 20.9834 19.059 21.4417 18.3248 21.7999C19.059 22.158 19.8101 22.6164 20.3968 23.2031C20.9836 23.7898 21.4419 24.541 21.8 25.2751C22.1582 24.541 22.6165 23.7898 23.2033 23.2031C23.79 22.6164 24.5411 22.158 25.2753 21.7999C24.5411 21.4417 23.79 20.9834 23.2033 20.3967C22.6165 19.81 22.1582 19.0588 21.8 18.3246ZM20.8533 15.8808C20.4249 17.133 19.8495 18.3984 19.124 19.1239C18.3986 19.8493 17.1332 20.4247 15.8809 20.8531C15.8021 20.8801 15.7233 20.9065 15.6447 20.9323C15.4012 21.0123 15.1594 21.0867 14.9236 21.1555C14.8117 21.1882 14.7012 21.2196 14.5924 21.2497C14.1372 21.3759 14.1372 22.2239 14.5924 22.3501C14.7012 22.3802 14.8117 22.4116 14.9236 22.4443C15.1594 22.5131 15.4012 22.5875 15.6447 22.6675C15.7233 22.6933 15.8021 22.7197 15.8809 22.7466C17.1332 23.1751 18.3986 23.7504 19.124 24.4759C19.8495 25.2013 20.4249 26.4667 20.8533 27.719C20.8803 27.7978 20.9067 27.8766 20.9325 27.9552C21.0124 28.1988 21.0868 28.4405 21.1557 28.6763C21.1883 28.7882 21.2197 28.8987 21.2499 29.0075C21.3761 29.4627 22.224 29.4627 22.3502 29.0075C22.3804 28.8987 22.4118 28.7882 22.4444 28.6763C22.5133 28.4405 22.5877 28.1988 22.6676 27.9552C22.6934 27.8766 22.7198 27.7978 22.7468 27.719C23.1752 26.4667 23.7506 25.2013 24.476 24.4759C25.2015 23.7504 26.4669 23.1751 27.7192 22.7466C27.798 22.7197 27.8768 22.6933 27.9554 22.6675C28.1989 22.5875 28.4407 22.5131 28.6765 22.4443C28.7884 22.4116 28.8989 22.3802 29.0077 22.3501C29.4629 22.2239 29.4629 21.3759 29.0077 21.2497C28.8989 21.2196 28.7884 21.1882 28.6765 21.1555C28.4407 21.0867 28.1989 21.0123 27.9554 20.9323C27.8768 20.9065 27.798 20.8801 27.7192 20.8531C26.4669 20.4247 25.2015 19.8493 24.476 19.1239C23.7506 18.3984 23.1752 17.133 22.7468 15.8808C22.7198 15.8019 22.6934 15.7232 22.6676 15.6446C22.5877 15.401 22.5133 15.1593 22.4444 14.9234C22.4118 14.8116 22.3804 14.701 22.3502 14.5923C22.224 14.1371 21.3761 14.1371 21.2499 14.5923C21.2197 14.701 21.1883 14.8116 21.1557 14.9234C21.0868 15.1593 21.0124 15.401 20.9325 15.6446C20.9067 15.7232 20.8803 15.8019 20.8533 15.8808Z" fill={selected ? "#6366F1" : "#6B6F7A"}/>
<path d="M14.4554 10.566C14.3095 10.1284 13.6905 10.1284 13.5447 10.566L13.1795 11.6615C12.9406 12.3781 12.3783 12.9405 11.6616 13.1794L10.5661 13.5445C10.1285 13.6904 10.1285 14.3094 10.5661 14.4553L11.6616 14.8204C12.3783 15.0593 12.9406 15.6217 13.1795 16.3383L13.5447 17.4338C13.6905 17.8714 14.3095 17.8714 14.4554 17.4338L14.8205 16.3383C15.0594 15.6217 15.6218 15.0593 16.3384 14.8204L17.4339 14.4553C17.8715 14.3094 17.8715 13.6904 17.4339 13.5445L16.3384 13.1794C15.6218 12.9405 15.0594 12.3781 14.8205 11.6615L14.4554 10.566Z" fill={selected ? "#6366F1" : "#6B6F7A"}/>
</g>
<defs>
<filter id="filter0_i_1199_24166" x="0" y="0" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="-1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.717647 0 0 0 0 0.721569 0 0 0 0 0.741176 0 0 0 0.15 0"/>
<feBlend mode="normal" in2="shape" result="effect1_innerShadow_1199_24166"/>
</filter>
</defs>
</svg>

const SAAS2 = ({selected}) => <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" rx="20" fill="#B7B8BD" fill-opacity="0.07"/>
<path d="M20 9.80005C25.6334 9.80005 30.2001 14.3667 30.2001 20C30.2001 25.6334 25.6334 30.2001 20 30.2001C14.3667 30.2001 9.80005 25.6334 9.80005 20C9.80005 14.3667 14.3667 9.80005 20 9.80005ZM16.4092 24.2004L12.7241 24.2005C13.8864 26.2094 15.8567 27.6923 18.1906 28.2047C17.4017 26.891 16.8078 25.5561 16.4092 24.2004ZM27.276 24.2005L23.5909 24.2004C23.1923 25.5561 22.5984 26.891 21.8107 28.2036C24.1434 27.6923 26.1137 26.2094 27.276 24.2005ZM21.704 24.2003H18.2961C18.6931 25.3817 19.2607 26.5509 20 27.7093C20.7394 26.5509 21.307 25.3817 21.704 24.2003ZM15.9965 17.6006L11.9479 17.6C11.7216 18.3605 11.6 19.1661 11.6 20C11.6 20.8345 11.7217 21.6405 11.9483 22.4013L15.9967 22.4007C15.8657 21.6072 15.8 20.8069 15.8 20C15.8 19.1937 15.8656 18.3938 15.9965 17.6006ZM22.1756 17.6H17.8245C17.6747 18.3943 17.6 19.1941 17.6 20C17.6 20.8064 17.6748 21.6067 17.8247 22.4013H22.1754C22.3253 21.6067 22.4 20.8064 22.4 20C22.4 19.1941 22.3254 18.3943 22.1756 17.6ZM28.0522 17.6L24.0036 17.6006C24.1345 18.3938 24.2 19.1937 24.2 20C24.2 20.8069 24.1344 21.6072 24.0034 22.4007L28.0518 22.4013C28.2784 21.6405 28.4 20.8345 28.4 20C28.4 19.1661 28.2785 18.3605 28.0522 17.6ZM18.1894 11.7965L18.0354 11.8311C15.769 12.3742 13.8597 13.836 12.7234 15.8008L16.4088 15.8009C16.8075 14.4447 17.4015 13.1095 18.1894 11.7965ZM20 12.2908C19.2604 13.4496 18.6927 14.6192 18.2956 15.801H21.7045C21.3074 14.6192 20.7397 13.4496 20 12.2908ZM21.8095 11.7954L21.8717 11.8988C22.6293 13.1789 23.203 14.48 23.5913 15.8009L27.2767 15.8008C26.1145 13.7913 24.1439 12.3079 21.8095 11.7954Z" fill={selected ? "#6366F1" : "#6B6F7A"}/>
</svg>
const OnPremise = ({selected}) => <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" rx="20" fill="#B7B8BD" fill-opacity="0.07"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.4 14.9C10.4 12.4147 12.4147 10.4 14.9 10.4H19.1C21.4845 10.4 23.4358 12.2546 23.5902 14.6H25.1C27.5853 14.6 29.6 16.6147 29.6 19.1V25.1C29.6 27.5853 27.5853 29.6 25.1 29.6H23.6H21.8H14.9C12.4147 29.6 10.4 27.5853 10.4 25.1V14.9ZM21.8 27.8V14.9C21.8 13.4089 20.5912 12.2 19.1 12.2H14.9C13.4089 12.2 12.2 13.4089 12.2 14.9V25.1C12.2 26.5912 13.4089 27.8 14.9 27.8H21.8ZM23.6 27.8H25.1C26.5912 27.8 27.8 26.5912 27.8 25.1V19.1C27.8 17.6089 26.5912 16.4 25.1 16.4H23.6V27.8ZM14 15.1401C14 14.6431 14.403 14.2401 14.9 14.2401H15.5C15.9971 14.2401 16.4 14.6431 16.4 15.1401C16.4 15.6372 15.9971 16.0401 15.5 16.0401H14.9C14.403 16.0401 14 15.6372 14 15.1401ZM17.6 15.1401C17.6 14.6431 18.003 14.2401 18.5 14.2401H19.1C19.5971 14.2401 20 14.6431 20 15.1401C20 15.6372 19.5971 16.0401 19.1 16.0401H18.5C18.003 16.0401 17.6 15.6372 17.6 15.1401ZM14.9 17.4801C14.403 17.4801 14 17.883 14 18.3801C14 18.8771 14.403 19.2801 14.9 19.2801H15.5C15.9971 19.2801 16.4 18.8771 16.4 18.3801C16.4 17.883 15.9971 17.4801 15.5 17.4801H14.9ZM17.6 18.3801C17.6 17.883 18.003 17.4801 18.5 17.4801H19.1C19.5971 17.4801 20 17.883 20 18.3801C20 18.8771 19.5971 19.2801 19.1 19.2801H18.5C18.003 19.2801 17.6 18.8771 17.6 18.3801ZM14.9 20.72C14.403 20.72 14 21.1229 14 21.62C14 22.1171 14.403 22.52 14.9 22.52H15.5C15.9971 22.52 16.4 22.1171 16.4 21.62C16.4 21.1229 15.9971 20.72 15.5 20.72H14.9ZM17.6 21.62C17.6 21.1229 18.003 20.72 18.5 20.72H19.1C19.5971 20.72 20 21.1229 20 21.62C20 22.1171 19.5971 22.52 19.1 22.52H18.5C18.003 22.52 17.6 22.1171 17.6 21.62ZM14.9 23.9599C14.403 23.9599 14 24.3629 14 24.8599C14 25.357 14.403 25.7599 14.9 25.7599H15.5C15.9971 25.7599 16.4 25.357 16.4 24.8599C16.4 24.3629 15.9971 23.9599 15.5 23.9599H14.9ZM17.6 24.8599C17.6 24.3629 18.003 23.9599 18.5 23.9599H19.1C19.5971 23.9599 20 24.3629 20 24.8599C20 25.357 19.5971 25.7599 19.1 25.7599H18.5C18.003 25.7599 17.6 25.357 17.6 24.8599ZM25.7 20C26.1971 20 26.6 19.5971 26.6 19.1C26.6 18.603 26.1971 18.2 25.7 18.2C25.203 18.2 24.8 18.603 24.8 19.1C24.8 19.5971 25.203 20 25.7 20ZM26.6 22.1C26.6 22.5971 26.1971 23 25.7 23C25.203 23 24.8 22.5971 24.8 22.1C24.8 21.603 25.203 21.2 25.7 21.2C26.1971 21.2 26.6 21.603 26.6 22.1ZM25.7 26C26.1971 26 26.6 25.5971 26.6 25.1C26.6 24.603 26.1971 24.2 25.7 24.2C25.203 24.2 24.8 24.603 24.8 25.1C24.8 25.5971 25.203 26 25.7 26Z" fill={selected ? "#6366F1" : "#6B6F7A"}/>
</svg>
const HelpMe = ({selected}) => <div style={{width: 40, height: 40}}>
    <img alt='fdvdf' src={require("../../../../assets/img/signup_face.png")} />
</div>




const getTemplates = (t) => [
    {key: "SaaS", title: t("SaaS"), subtitle: t("All network infrastructure and computing platforms provided. Just sign up and use the services."), icon: SAAS1 },
    {key: "Managed Services", title: t("Managed Services"), subtitle: t("Let our team manage and maintain your system for you."), icon: SAAS1 },
    {key: 'On-premise deployment', title: t("On-premise deployment"), subtitle: t("Local or private cloud deployment. Users provide the infrastructure; we provide tailored software solutions."), icon: OnPremise },
    {key: "Marketing Package", title: t("Marketing Package"), subtitle: t("Boost your organization's visibility with a full suite of marketing tools and support."), icon: OnPremise },
    {key: "DaaS", title: t("DaaS"), subtitle: t("Data as a Service: Simplified data management and accessibility through cloud services."), icon: OnPremise },
    {key: "Self-Hosted", title: t("Self-Hosted"), subtitle: t("Fully self-managed hosting on your infrastructure with complete control over data and systems."), icon: OnPremise },
    // {key: "Help Me Get Started", title: t("Help Me Get Started"), subtitle: t("Book a meeting with an expert to help you get started with our system."), icon: HelpMe },
]

const _Step3 = (props) => {
    const { classes, allowNext, onNext, onPrev, orgName, templateName, setTemplateName } = props
    const [t] = useTranslation("admin")

    // const templates = getTemplates(t);

    return <div className={classes.container}>
        <div className={classes.title}>{t("Terms of Service")}</div>
        <div className={classes.subtitle}>{<div className={classes.sign}>By signing up, you agree to our <a href='https://www.tuqqi.com/terms-of-service' target='_new'>terms of service</a> and <a href='https://www.tuqqi.com/privacy-policy' target='_new'>privacy policy</a></div>}</div>

        <div className={classes.btns}>
            <div onClick={onPrev} className={`${classes.btnWhite}`}>
                <div className={classes.btnTextWhite}>{t("Back")}</div>
            </div>
            <div  onClick={onNext} className={`${classes.btn} ${!allowNext ? classes.disabledBtn : ""}`}>
                <div className={classes.btnText}>{t("Agree")}</div>
            </div>
        </div>
        {/* <div className={classes.content1}>
            {templates.map((x, i) => <div key={x.key + i} onClick={() => {if(templateName !== x.key) setTemplateName(x.key)}} className={classes.content}>
                <div>
                    {<x.icon selected={templateName === x.key} />}
                </div>
                <div className={classes.titles}>
                    <div className={`${classes.label} ${templateName === x.key ? classes.selLabel : ""}`}>{x.title}</div>
                    <div className={classes.labelDesc}>{x.subtitle}</div>
                </div>
        </div>)} */}
        {/* </div> */}
    </div>
}

const mapStateToProps = (state, ownProps) => ({

})

const mapDispatchToProps = (dispatch) => ({ dispatch })


export const Step3 = compose(
    withStyles(styles, { withTheme: true }),   
    connect(mapStateToProps, mapDispatchToProps),
    withErrorCatcher("Failed loading user, Please Contact Tuqqi Support")
)(_Step3)